import { BaseCommentFragment } from "graphql.generated";
import { Delta } from "quill";
import { CallState } from "src/app/utilities/state.util";

export interface EditableComment {
  id: string;
  parentId?: string;
  contents?: Delta;
  authorName?: string;
  author?: {
    id: string;
    familyName?: string;
    givenName?: string;
  };
  threadId?: string;
  modeId?: string;
  subject?: Delta;
  replies: EditableComment[];
  createdAt: number;
  callState: CallState,
  metadata?: any,
  attributes?: string[],
  artifacts?: BaseCommentFragment['artifacts'],
}

export interface PendingFile {
  id: string;
  name: string;
  size: number;
  type: string;
}

export const jobActivityInitialState = {
  addComment: {
    commentModeId: 'Comment' as string,
    contents: new Delta(),
    subject: new Delta(),
    pendingFiles: [] as PendingFile[],
  },
  comments: [] as EditableComment[],
  addReplyContents: {} as Record<string, Delta>,
  addReplyPendingFiles: {} as Record<string, PendingFile[]>,
  editCommentContents: {} as Record<string, Delta>,
  repliesCollapsed: {} as Record<string, true>,
} as const;
